import { fs } from "../firebase.ts";
import { doc, getDoc } from "firebase/firestore";
import { Crypto } from "../models/Crypto.ts";
import { getPublicName, getHero } from "../components/global.ts";

export class Me {
    private crypto = new Crypto();

    async getName3(uid: string) {
        const profile = await this.getUserProfile(uid);
        return this.getName2(profile);
    }

    async getName(key: string): Promise<string> {
        const profile = await this.getProfile(key);
        return this.getName2(profile);
    }

    getName2(profile: any) {
        if (profile) {
            if (profile.displayName) return profile.displayName;
            else if (profile.username) return "@" + profile.username;
            else return "Someone"; // key.truncate()
        } else {
            return "Someone"; // key.truncate()
        }
    }

    async getNames(to: any): Promise<string> {
        if (to && to.length > 0) {
            const names = [];
            for (const recipient of to) {
                names.push(await this.getName(recipient.p));
            }
            return this.joinWithAnd(names);
        } else {
            return "You"; // for general public
        }
    }

    private joinWithAnd(items: string[]): string {
        if (items.length <= 1) return items.join("");
        if (items.length === 2) return items.join(" and ");
        return (
            items.slice(0, -1).join(", ") + ", and " + items[items.length - 1]
        );
    }

    async getUserName(key: string): Promise<string | null> {
        const profile = await this.getProfile(key);
        return profile ? getPublicName(profile) : null; //key.truncate();
    }

    async getProfile(key: string) {
        const uid = await this.getUserId(key);
        return uid ? await this.getUserProfile(uid) : null;
    }

    async getUserId(key: string): Promise<string | null> {
        const safe = await this.getPublicSafe(key);
        if (safe) return safe.uid;
        else {
            const locker = await this.getPublicLocker(key);
            return locker ? locker.uid : null;
        }
    }

    async getUserProfile(uid: string) {
        const docRef = doc(fs, "users", uid);
        const docSnap = await getDoc(docRef);
        // if (docSnap.metadata.fromCache) {
        //     console.log(
        //         "This data came from the local cache and might be partial/old."
        //     );
        // } else {
        //     console.log("This data is fresh from the server.");
        // }
        return { id: docSnap.id, ...docSnap.data() } as any;
    }

    ///

    // get locker or safe name
    async getAddressName(key: string, uid: string): Promise<string> {
        const name = await this.crypto.getName(key);
        if (name) return name.truncate2(30);
        else {
            const safe = await this.getSafe(uid, key);
            return safe ? safe.name : key.truncate();
        }
    }

    async getFromAddressType(
        key: string,
        uid: string
    ): Promise<"locker" | "safe" | null> {
        const locker = await this.getLocker(key);
        if (locker) return "locker";
        else {
            const safe = await this.getSafe(uid, key);
            return safe ? "safe" : null;
        }
    }

    async getFromAddressType2(
        key: string,
        uid: string | null
    ): Promise<"locker" | "safe" | null> {
        if (uid) return this.getFromAddressType(key, uid);
        else {
            const locker = await this.getLocker(key);
            return locker ? "locker" : null;
        }
    }

    async getToAddressType(key: string): Promise<"locker" | "safe" | null> {
        const safe = await this.getPublicSafe(key);
        if (safe) return "safe";
        else {
            const locker = await this.getPublicLocker(key);
            return locker ? "locker" : null;
        }
    }

    async getToAddressType2(
        key: string,
        uid: string | null
    ): Promise<"locker" | "safe" | null> {
        return this.getFromAddressType2(key, uid);
    }

    // helpers

    async publicLockerExists(): Promise<boolean> {
        const trustkey = getHero().trustkey;
        const id = trustkey ? await this.getLocker(trustkey) : null;
        return !!id;
    }

    async getLocker(key: string): Promise<string | null> {
        return await this.crypto.getKeyId(key);
    }

    async getSafe(uid: string, key: string) {
        // uid = "" for logged out user
        if (uid) {
            const docRef = doc(fs, "users", uid, "heartkeys", key);
            const docSnap = await getDoc(docRef);
            return docSnap.exists() ? docSnap.data() : null;
        } else return null;
    }

    ///

    private async getPublicLocker(key: string) {
        const trustkeyDocRef = doc(fs, "trustkeys", key);
        const trustkeyDocSnap = await getDoc(trustkeyDocRef);
        return trustkeyDocSnap.exists() ? trustkeyDocSnap.data() : null;
    }

    private async getPublicSafe(key: string) {
        const heartkeyDocRef = doc(fs, "heartkeys", key);
        const heartkeyDocSnap = await getDoc(heartkeyDocRef);
        return heartkeyDocSnap.exists() ? heartkeyDocSnap.data() : null;
    }
}
